import CustomStyle from './custom-style.js';

export default class EmptyCustomStyle extends CustomStyle {
  constructor() {
    super('empty', {});
  }

  overrideWith(customStyle: CustomStyle): CustomStyle {
    return customStyle;
  }
}
